































import { defineComponent, ref, toRef, watch } from "@vue/composition-api";
import { debounce } from "lodash-es";
import { BlockedLocationAutocomplete } from "@scrile/api-provider/dist/api/BlockedLocationsProvider";
import providers from "@/lib/api";
import { getLocationName } from "@/lib/location";
import { FormValue } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseInput from "@/components/BaseInput";
import BaseSpinner from "@/components/BaseSpinner";
import CustomScroll from "@/components/CustomScroll";

const emptyLocation: BlockedLocationAutocomplete = { city: "", stateCode: "", countryCode: "" };

export default defineComponent({
  name: "LocationSearchInput",
  components: { BaseSpinner, CustomScroll, BaseInput, BaseIcon },
  props: {
    location: { type: String, default: "" },
  },
  setup(props, { emit }) {
    const locationCity = ref<FormValue>("");
    const showOptions = ref(false);
    const loading = ref(false);
    const options = ref<(BlockedLocationAutocomplete & { text: string })[]>([]);

    const mappedLocations = (locations: BlockedLocationAutocomplete[]) => {
      return locations.map(item => {
        const text = getLocationName(item);
        return {
          text,
          ...item,
        };
      });
    };

    const getLocations = debounce(async (text?: string) => {
      emit("setLocation", emptyLocation);
      if (!text) {
        showOptions.value = false;
        return;
      }
      try {
        loading.value = true;
        const response = await providers.BlockedLocationsProvider.searchAutocomplete({ text });
        options.value = mappedLocations(response);
        showOptions.value = true;
      } finally {
        loading.value = false;
      }
    }, 500);

    const setLocation = ({ text, countryCode, stateCode, city }: BlockedLocationAutocomplete & { text: string }) => {
      emit("setLocation", { city: city ?? "", stateCode: stateCode ?? "", countryCode: countryCode ?? "" });
      locationCity.value = text;
      showOptions.value = false;
    };

    const clear = () => {
      locationCity.value = "";
      emit("setLocation", emptyLocation);
      showOptions.value = false;
    };

    watch(toRef(props, "location"), value => (locationCity.value = value));

    return {
      locationCity,
      showOptions,
      options,
      loading,
      clear,
      getLocations,
      setLocation,
    };
  },
});
